import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  SxProps,
  Theme,
} from "@mui/material";

interface ByzMuiFormSelectProps {
  label: string;
  value: any;
  onChange: (event: SelectChangeEvent<any>) => void;
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: "small" | "medium";
  disabled?: boolean;
  required?: boolean;
  FormControlSx?: SxProps<Theme>;
  SelectSx?: SxProps<Theme>;
}

const ByzMuiFormSelect: React.FC<ByzMuiFormSelectProps> = ({
  label,
  value,
  onChange,
  children,
  fullWidth = true,
  size = "small",
  disabled = false,
  required = false,
  FormControlSx,
  SelectSx,
}) => {
  const defaultFormControlSx: SxProps<Theme> = {
    "& .MuiInputLabel-root": {
      color: "#2498f3 !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#2498f3 !important",
    },
    "& .MuiFormLabel-root": {
      color: "#2498f3 !important",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#2498f3 !important",
    },
    "& .MuiSelect-root": {
      height: size === "small" ? "36px" : "auto",
    },
    "& .MuiOutlinedInput-root": {
      height: size === "small" ? "36px" : "auto",
    },
  };

  const defaultSelectSx: SxProps<Theme> = {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
  };

  const mergedFormControlSx = { ...defaultFormControlSx, ...FormControlSx };
  const mergedSelectSx = { ...defaultSelectSx, ...SelectSx };

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      disabled={disabled}
      required={required}
      sx={mergedFormControlSx}
    >
      <InputLabel shrink>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        displayEmpty
        inputProps={{ "aria-label": label }}
        sx={mergedSelectSx}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default ByzMuiFormSelect;

